<template>
    <div class="commonInfo">
        <div class="priority">
          <div class="low">
            <div class="icon"></div>
            <div class="title">Low priority</div>
            <div v-if="recommendedFees" class="value">{{recommendedFees.hourFee}} sat/vB <span v-if="priorityPrices">(${{priorityPrices.low}})</span> </div>
          </div>
          <div class="medium">
            <div class="icon"></div>
            <div class="title">Medium priority</div>
            <div v-if="recommendedFees" class="value">{{recommendedFees.halfHourFee}} sat/vB <span v-if="priorityPrices">(${{priorityPrices.medium}})</span></div>
          </div>
          <div class="high">
            <div class="icon"></div>
            <div class="title">High priority</div>
            <div v-if="recommendedFees" class="value">{{recommendedFees.fastestFee}} sat/vB <span v-if="priorityPrices">(${{priorityPrices.high}})</span></div>
          </div>
        </div>
        <table class="table">
            <thead>
                <tr>
                    <th>Height</th>
                    <th>Timestamp</th>
                    <th>Mined</th>
                    <th>Transactions</th>
                    <th>Filled</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in blocks" :key="item.id">
                    <td>{{item.height}}</td>
                    <td>{{moment(item.timestamp * 1000).utc().format('MM.DD.YYYY HH:mm:ss')}}</td>
                    <td>{{moment(item.timestamp * 1000).fromNow()}}</td>
                    <td class="text-right">{{addCommas(item.tx_count)}}</td>
                    <td>
                      <div class="bar">
                        <div class="filled" :style="{'width': (item.size / FILLED_BLOCK_SIZE) * 100 + '%'}"></div>
                        <div class="size" :style="{'width': (item.size / FILLED_BLOCK_SIZE) * 100 + '%'}"> {{bytesToSize(item.size)}} </div>
                      </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
let interval = null;
// 2MB
const FILLED_BLOCK_SIZE = 2097152;
export default {
  name:'commonInfo',
  props:['blocks','BTC_PRICE'],
  data: () => ({
    FILLED_BLOCK_SIZE:FILLED_BLOCK_SIZE,
    recommendedFees:null,
  }),
  computed:{
    priorityPrices(){
      if (this.BTC_PRICE && this.recommendedFees){
        return {
          low: ((this.recommendedFees.hourFee * 250 / 100000000) * this.BTC_PRICE).toFixed(2),
          medium: ((this.recommendedFees.halfHourFee * 250 / 100000000) * this.BTC_PRICE).toFixed(2),
          high: ((this.recommendedFees.fastestFee * 250 / 100000000) * this.BTC_PRICE).toFixed(2),
        }
      }
      return null
    }
  },
  methods:{
    getRecommendedFees(){
      axios.get('https://mempool.space/api/v1/fees/recommended').then(response => {
        if (response.status == 200)
        this.recommendedFees = response.data
      });
    }
  },
  created(){
    this.getRecommendedFees();
    // check recommended fees every 5 seconds
    interval = setInterval(this.getRecommendedFees,5000);
  },
  beforeDestroy(){
    clearInterval(interval);
  }
}
</script>

<style lang="scss" scoped>
.commonInfo{
  .priority{
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    & > div{
      width: 182px;
      height: 76px;
      background: var(--table-th-bg);
      border-radius: 4px;
      position: relative;
      padding-top: 14px;
      padding-left: 38px;
      margin: 0px 10px;
      .icon{
        width: 2px;
        height: 46px;
        background: #E6E7EA;
        position: absolute;
        left: 16px;
        &:after{
          content: '';
          width: 10px;
          height: 10px;
          background: #3868F8;
          border-radius:10px;
          display: block;
          position: absolute;
          left: -4px;
          bottom: 5px;
        }
      }
      &.medium .icon:after{
          bottom: 18px;
      }
      &.high .icon:after{
          top: 5px;
      }
      .title{
        font-weight: 600;
        font-size: 13px;
        color: var(--font-color);
        margin-bottom: 6px;
      }
      .value{
        font-size: 13px;
        color: #667090;
        span{
          margin-left: 5px;
          color:#4BC79A;
        }
      }
    }
  }
  table{
      width: 100%;
      thead{
          th{
              &:last-child{
                  width: 45%;
              }
          }
      }
      tbody{
        tr{
            td{
              padding: 3px 3px;
              .bar{
                height: 22px;
                background: rgba(68, 75, 255, 0.1);
                border: 1px solid rgba(56, 104, 248, 0.2);
                border-radius: 4px;
                position: relative;
                margin: 0px 5px;
                .filled{
                  position: absolute;
                  height: 20px;
                  background: #444BFF;
                  border-radius: 4px;
                  max-width: 100%;
                }
                .size{
                  position: absolute;
                  min-width: 90px;
                  max-width: 100%;
                  color: #A9BEFF;
                  height: 20px;
                  line-height: 20px;
                  text-align: center;
                }
              }
            }
        }
      }
  }
}

</style>